var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offset-lg-2 col-lg-8"},[_c('youtube',{attrs:{"player-width":_vm.playerWidth,"player-height":_vm.playerHeight,"video-id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }